


























import { Form, FormItem } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'

import Customer from '@/models/customer'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    Checkbox,
  },
})
export default class CustomerSubscriptionsForm extends Vue {
  @Prop() customer!: Customer

  onMarketingSubscriptionClick() {
    this.$emit(
      'on-marketing-subscription-click',
      !this.customer.isSubscriptionActive,
    )
  }
}
